import React, { useEffect, useState, useContext } from "react";
import { Box, Typography } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import TableAllData from "../CustomTable/TableAllData";
import LoaderAnimation from "pages/LoaderAnimation";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

const formatRate = (amount, currencyCode) => {
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode || 'USD',
        }).format(amount);
    } catch {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    }
};

const columns = [
    { Header: 'Source',         accessor: 'integrationName' },
    { Header: 'Effective Date', accessor: 'effectiveDate' },
    { Header: 'Pay Schedule',   accessor: 'paySchedule' },
    { Header: 'Pay Type',       accessor: 'payType' },
    { Header: 'Pay Rate',       accessor: 'payRateDisplay' },
];

function PayrollDetails({ insuredId }) {
    const { companyId } = useContext(PrivateRoutesContext);
    const [data, setData]           = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!insuredId) return;
        setIsLoading(true);
        apiGet(apiUrls.getInsuredPayrollDetails(insuredId, companyId))
            .then(res => {
                const raw = res.data || [];
                setData(raw.map(d => {
                    const formattedRate = d.payRate != null ? formatRate(d.payRate, d.currency) : '';
                    const paidPer       = d.paidPer ? d.paidPer.toLowerCase() : '';
                    return {
                        ...d,
                        effectiveDate:  d.effectiveDate
                            ? new Date(d.effectiveDate).toLocaleDateString()
                            : '',
                        payRateDisplay: formattedRate && paidPer
                            ? `${formattedRate}/${paidPer}`
                            : formattedRate,
                    };
                }));
            })
            .catch(() => setData([]))
            .finally(() => setIsLoading(false));
    }, [insuredId, companyId]);

    if (isLoading) {
        return <Box sx={{ position: 'relative', height: 120 }}><LoaderAnimation /></Box>;
    }

    if (data.length === 0) {
        return (
            <Typography color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                No payroll data available.
            </Typography>
        );
    }

    return (
        <Box className="container-fluid">
            <TableAllData
                key={`payroll-${insuredId}`}
                columns={columns}
                data={data}
                isLoading={false}
            />
        </Box>
    );
}

export default PayrollDetails;
